export default __webpack_public_path__ + "static/GRID22-map-youth-es-b7214d6171e692807ef893b75c1af0b2.png";